module.exports = __webpack_public_path__ + "static/media/10_shape_l.20422b1c.webp";